if (!customElements.get('akuma-desktop-nav')) {
  customElements.define('akuma-desktop-nav', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const desktop = window.matchMedia('(min-width: 990px)');
      const hover = window.matchMedia('(hover: hover) and (pointer: fine)');
      const header = this.closest('.header-wrapper');
      const menus = [...this.querySelectorAll('header-menu')];
      const close = (menu) => {
        menu.querySelector('details').open = false;
        menu.querySelector('summary').setAttribute('aria-expanded', 'false');
      };
      this.timers = new Set();
      menus.forEach((menu) => {
        const details = menu.querySelector('details');
        const summary = menu.querySelector('summary');
        let timer;
        menu.addEventListener('pointerenter', () => {
          clearTimeout(timer);
          if (!desktop.matches || !hover.matches) return;
          header.querySelectorAll('akuma-desktop-nav header-menu').forEach((other) => {
            if (other !== menu) close(other);
          });
          document.documentElement.style.setProperty('--header-bottom-position-desktop', `${header.getBoundingClientRect().bottom}px`);
          details.open = true;
          summary.setAttribute('aria-expanded', 'true');
        }, options);
        menu.addEventListener('pointerleave', () => {
          timer = setTimeout(() => {
            this.timers.delete(timer);
            if (!menu.contains(document.activeElement)) close(menu);
          }, 250);
          this.timers.add(timer);
        }, options);
        details.addEventListener('toggle', () => {
          summary.setAttribute('aria-expanded', String(details.open));
          if (details.open) {
            header.querySelectorAll('akuma-desktop-nav header-menu').forEach((other) => {
              if (other !== menu) close(other);
            });
          }
          header.preventHide = !!header.querySelector('akuma-desktop-nav details[open]');
        }, options);
        menu.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && details.open) {
            event.preventDefault();
            event.stopPropagation();
            close(menu);
            summary.focus();
          }
        }, options);
      });
      document.addEventListener('pointerdown', (event) => {
        if (!this.contains(event.target)) menus.forEach(close);
      }, options);
      desktop.addEventListener('change', () => menus.forEach(close), options);
    }
    disconnectedCallback() {
      this.controller.abort();
      this.timers.forEach(clearTimeout);
    }
  });
}
